/**
 * @typedef {Object} Elements
 * @property {HTMLElement | null} countNumberEl
 * @property {HTMLElement | null} gaugeFillEl
 * @property {HTMLElement | null} goalNumberEl
 * @property {HTMLElement | null} barWrapperEl
 * @property {HTMLElement | null} percentageEl
 */

class WaitlistProgress extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.currentCount = 0;
    /** @type {number} */
    this.finalGoal = 5000;
    /** @type {Elements} */
    this.elements = {
      countNumberEl: null,
      gaugeFillEl: null,
      goalNumberEl: null,
      barWrapperEl: null,
      percentageEl: null
    };
  }

  connectedCallback() {
    // Get data from attributes
    const count = parseInt(this.dataset.initialCount || '0', 10) || 0;
    const finalGoal = parseInt(this.dataset.finalGoal || '5000', 10) || 5000;

    // Store initial values
    this.currentCount = count;
    this.finalGoal = finalGoal;

    console.log('🚀 Waitlist Progress initialized');
    console.log('📊 Initial count:', count);
    console.log('🏁 Final Goal:', finalGoal);

    // Get elements
    this.elements = {
      countNumberEl: this.querySelector('.waitlist-gauge__count-number'),
      gaugeFillEl: this.querySelector('.waitlist-gauge__fill'),
      goalNumberEl: this.querySelector('.waitlist-gauge__goal-number'),
      barWrapperEl: this.querySelector('.waitlist-gauge__bar-wrapper'),
      percentageEl: this.querySelector('.waitlist-gauge__percentage')
    };

    // Initial render
    this.updateDisplay(count);

    // Vérifier si on revient d'une inscription réussie
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === '1') {
      console.log('✅ Success parameter detected! Incrementing count optimistically');
      this.currentCount += 1;
      this.updateDisplay(this.currentCount);
      
      // Scroll vers la section après le rechargement
      setTimeout(() => {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      
      // Nettoyer l'URL sans recharger la page
      window.history.replaceState({}, '', window.location.pathname);
      console.log('🧹 URL cleaned');
    }
  }

  /**
   * @param {number} count
   */
  updateDisplay(count) {
    // Progression directe vers l'objectif final (pas de paliers)
    const progress = Math.min((count / this.finalGoal) * 100, 100);

    console.log('🎨 Updating display - Count:', count, '| Goal:', this.finalGoal, '| Progress:', progress.toFixed(1) + '%');

    // Update the gauge
    const gaugeFillEl = this.elements.gaugeFillEl;
    if (gaugeFillEl instanceof HTMLElement) {
      gaugeFillEl.style.setProperty('--progress', `${progress}%`);
    }

    const countNumberEl = this.elements.countNumberEl;
    if (countNumberEl) {
      countNumberEl.textContent = count.toLocaleString('fr-FR');
    }

    const goalNumberEl = this.elements.goalNumberEl;
    if (goalNumberEl) {
      goalNumberEl.textContent = this.finalGoal.toLocaleString('fr-FR');
    }

    // Update percentage display
    const percentageEl = this.elements.percentageEl;
    if (percentageEl) {
      percentageEl.textContent = `${progress.toFixed(1)} %`;
    }

    // Update aria attributes
    const barWrapperEl = this.elements.barWrapperEl;
    if (barWrapperEl) {
      barWrapperEl.setAttribute('aria-valuenow', String(count));
      barWrapperEl.setAttribute('aria-valuemax', String(this.finalGoal));
    }
  }
}

customElements.define('waitlist-progress', WaitlistProgress);
